<div class="language-dialog-container  popup-container">
  <div class="language-header">
    <span class="language-title">{{ 'dialog.languages' | translate }}</span>
  </div>

  <div class="language-list">
    <span matRipple (click)="switchLanguage('fr')">Français</span>
    <span matRipple (click)="switchLanguage('en')">English</span>
  </div>

</div>
